import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import i1zv from './i1zv_20211024';
import c42v1a from './c42v1a';

const c = {
  n_lclSttTypeVle: 0,
  n_lclSttTypeList: 1,
  n_lclSttTypeDny: 2,
};

const useLclStt = (pn_type=0,pa_ini=null) => {
  const _l = React.useState(pa_ini);
  switch (pn_type) {
    case c.n_lclSttTypeDny:
      const _h_set = (pd) => {
        if (pd) {
          _l[1]({ ..._l[0], ...pd,});
        }
        else {
          _l[1]({});
        };
      };
      return {
        crt: _l[0],
        set: _h_set,
      };
    default:
      return {
        crt: _l[0],
        set: _l[1],
      };
  }
};

const loadAsync = (pd={
  elm: null,
  cnd: null,
}) => new Promise( _o_end1 => {
  const _c20r_fst = global.t?.state.sgcd_cmnStgs.c20r_fst;
  const _elm = pd.elm;
  let _cnd = `${_elm}b21f=${_c20r_fst} and ${_elm}cz1i=10 and _vsn=_ltt`;
  if (pd.cnd) _cnd += ` and (${pd.cnd})`;
  //ff.l('I1zv8 21: {}'.f(_cnd));
  ff.myCR_send_json({
    method: 'POST',
    url: ic.g_url1,
    type: 'slc',
    d_vals: {
      elm: pd.elm,
      n_dms: 3,
      cnd: _cnd,
    },
  })
  .then( _res => {
    _o_end1(_res);
  });

});

let _l_sctC30rs = []; // for select
//let _d_rfrI10rs = {}; // for rfr
let _l_sctI10rs = {}; // for select
let _b_1050 = false;

const _loadTopAsync = (pd={
  d_cnds: null,
  sl_i1zrs: null,
}) => new Promise( _o_end1 => {
  cf.s();
  const _c20r_fst = global.t?.state.sgcd_cmnStgs.c20r_fst;
  const _i1zri21dStt = pd.d_cnds.i1zri21dStt;
  const _i1zri21dEnd = pd.d_cnds.i1zri21dEnd;
  const _i1zrb31f = pd.d_cnds.i1zrb31f;
  //const _i1zrs11i = pd.d_cnds.i1zrs11i;
  const _i1z1s11i = pd.d_cnds.i1z1s11i; // 支払状況
  let _cnd = '';
  _cnd = `
    i1zrb21f = ${_c20r_fst}
    and _vsn = _ltt
    and i1zrs11i in (80, 90)
    and exists (
      select * from t_c30r where (
        c30rb21f = ${_c20r_fst} 
        and t_c30r._vsn = t_c30r._ltt 
        and t_c30r._fst = i1zrb31f
        and c30rbk1f in (
          select _fst from t_i15r where (
            i15rb21f = ${_c20r_fst}
            and _vsn = _ltt
            and i15rt11i = 10
          ) 
        )
      )
    )
  `;
  if (_i1zri21dStt) _cnd += ((_cnd) ? ' and ' : '') + `i1zri21d>="${_i1zri21dStt}"`;
  if (_i1zri21dEnd) _cnd += ((_cnd) ? ' and ' : '') + `i1zri21d<="${_i1zri21dEnd}"`;
  if (_i1zrb31f) _cnd += ((_cnd) ? ' and ' : '') + `i1zrb31f=${_i1zrb31f}`;
  //if (_i1zrs11i == 80) _cnd += ((_cnd) ? ' and ' : '') + `i1zrs11i = 80`;
  //if (_i1zrs11i == 90) _cnd += ((_cnd) ? ' and ' : '') + `i1zrs11i = 90`;
  //if (_i1zrs11i == 99) _cnd += ((_cnd) ? ' and ' : '') + `i1zrs11i in (80, 90)`;
  if (_i1z1s11i == 0) _cnd += ((_cnd) ? ' and ' : '') + `exists ( select * from t_i1z1 where i1z1b21f=${_c20r_fst} and _vsn=_ltt and i1z1b61k=t_i1zr._key and i1z1s11i=0 )`;
  if (_i1z1s11i == 10) _cnd += ((_cnd) ? ' and ' : '') + `exists ( select * from t_i1z1 where i1z1b21f=${_c20r_fst} and _vsn=_ltt and i1z1b61k=t_i1zr._key and i1z1s11i=10 )`;
  ff.l('i1zv8 105: {}'.f(_cnd));
  loadAsync({
    elm :'i1zr',
    cnd: _cnd,
  })
  .then( async _r => {
//    pd.sl_i1zrs.set(_r);
    const _l = await Promise.all(
      Array.from(_r).sort( (_d1, _d2) => {
        if (_d1.i1zri21d >_d2.i1zri21d) {
          return  1;
        }
        if (_d1.i1zri21d <_d2.i1zri21d) {
          return -1;
        }
        return 0;
      }).map( async _d => {
        const _cnd = `i1z1b61k=${_d._key}`;
        const _l2 = await loadAsync({
          elm :'i1z1',
          cnd: _cnd,
        })
//        ff.l('I1zv8 95: {}'.f(_l2));
        return {
          ..._d,
          ...( _l2 ? _l2[0] : null),
        }
      })
    );
    pd.sl_i1zrs.set(_l);
    cf.h();
    _o_end1(null);
  });
});

const _ctrHdr = React.memo((pd={
  sl_i1zrs: null,
  sc_c30rs: null,
}) => {

  const _sc_cnds = useLclStt(c.n_lclSttTypeDny, {
    i1zri21dStt: ff.myDT_getDate('today'), 
    i1zri21dEnd: ff.myDT_add('day', ff.myDT_getDate('today'), 7),
    i1zrb31f: null,
    //i1zrs11i: 99,
    i1z1s11i: 99,
  });

/*
  const _sc_c30rs = useLclStt(c.n_lclSttTypeList, []);
  React.useEffect(() => {
    if ( global.t?.state.sgcd_cmnStgs ) {

      loadAsync({
        elm : `c30r`,
      })
      .then( _r => {
        const _l = Array.from(_r).map( _d => ({
          ..._d,
          key: _d._fst,
          pfx: `${_d.c30rc11s} ${_d.c30rc31s}`,
          sch: `${_d.c30rc11s} ${_d.c30rc31s}`,
        }));
        _sc_c30rs.set(_l);

        _loadTopAsync({
          d_cnds: _sc_cnds.crt,
          sl_i1zrs: pd.sl_i1zrs,
        });
      });
    }
  }, [
    global.t?.state.sgcd_cmnStgs,
  ]);
*/

  React.useEffect(() => {
    if ( global.t?.state.sgcd_cmnStgs ) {
      _loadTopAsync({
        d_cnds: _sc_cnds.crt,
        sl_i1zrs: pd.sl_i1zrs,
      });
    }
  }, [
    global.t?.state.sgcd_cmnStgs,
  ]);

  return ([
    ce.c(ce.PckDate, cf.f('i1zri21d', { // 利用日
      key: -10, 
      b_vsb: true,
      b_edit: true,
      b_row: true,
      b_rvs: true,
      n_col: 8,
      d_stlCtas: {
        marginLeft: ic.m(1),
      },
      ctlVal: _sc_cnds.crt.i1zri21dStt,
      o_onChgAsCld: _d => {
        _sc_cnds.set({
          i1zri21dStt: _d.key,
        });
      },
    })),
    ce.c(ce.PckDate, cf.f('i1zri21d', { // 利用日
      pfx: '〜',
      key: -20, 
      b_vsb: true,
      b_edit: true,
      b_row: true,
      b_rvs: true,
      n_col: 8,
      d_stlCtas: {
        marginLeft: ic.m(1),
      },
      ctlVal: _sc_cnds.crt.i1zri21dEnd,
      o_onChgAsCld: _d => {
        _sc_cnds.set({
          i1zri21dEnd: _d.key,
        });
      },
    })),
    ce.c(ce.PckSch, cf.f('i1zrb31f', { // 団体
      key: -30, 
      b_vsb: true,
      b_edit: true,
      b_row: true,
      b_rvs: true,
//      ld_iss: pd.sc_c30rs.crt,
      ld_iss: _l_sctC30rs,
      n_col: 15,
      d_stlCtas: {
        marginLeft: ic.m(1),
      },
      ctlVal: _sc_cnds.crt.i1zrb31f,
      o_onChgAsCld: _d => {
        _sc_cnds.set({
          i1zrb31f: _d.key,
        });
      },
    })),
/*
    ce.c(ce.Pck, cf.f('i1zrs11i', { // 予約状況
      key: -3, 
      b_vsb: true,
      b_edit: true,
      b_row: true,
      b_rvs: true,
      n_col: 9,
      d_stlCtas: {
        marginLeft: ic.m(1),
      },
      ld_iss: [
        { key:  99, pfx: '仮予約＋本予約' },
        { key:  80, pfx: '仮予約' },
        { key:  90, pfx: '本予約' },
      ],
      ctlVal: _sc_cnds.crt.i1zrs11i,
      o_onChgAsCld: _d => {
        _sc_cnds.set({
          i1zrs11i: _d.key,
        });
      },
    })),
*/
    ce.c(ce.Pck, cf.f('i1z1s11i', { // 支払状況
      key: -40, 
      b_vsb: true,
      b_edit: true,
      b_row: true,
      b_rvs: true,
      n_col: 9,
      d_stlCtas: {
        marginLeft: ic.m(1),
      },
      ld_iss: [
        { key:  99, pfx: 'すべて' },
        { key:   0, pfx: '未払' },
        { key:  10, pfx: '支払済' },
      ],
      ctlVal: _sc_cnds.crt.i1z1s11i,
      o_onChgAsCld: _d => {
        _sc_cnds.set({
          i1z1s11i: _d.key,
        });
      },
    })),
    ce.c(ce.BtnIconPfx, {
      key: -50, 
      b_vsb: true,
      b_row: (ic.g_dvcMode == 's' ) ? false : true,
      iconName: 'search',
      pfx: '検索',
      o_onPrs: () => _loadTopAsync({
        d_cnds: _sc_cnds.crt,
        sl_i1zrs: pd.sl_i1zrs,
      }),
      d_stlCtas: {
        marginLeft: ic.m(1),
      }
    }),

  ]);
});

const _root = (pd={}) => {

  const _sl_i1zrs = useLclStt(c.n_lclSttTypeList, []);

  React.useEffect(() => {
    if ( global.t?.state.sgcd_cmnStgs ) {
      cf.s();
      loadAsync({
        elm : `c30r`,
      })
      .then( _r => {
        _l_sctC30rs = Array.from(_r).map( _d => ({
          ..._d,
          key: _d._fst,
          pfx: `${_d.c30rc11s} ${_d.c30rc31s}`,
          sch: `${_d.c30rc11s} ${_d.c30rc31s}`,
        }));
        loadAsync({
          elm : `i10r`,
        })
        .then( _r => {
          _l_sctI10rs = Array.from(_r).map( _d => ({
            ..._d,
            key: _d._fst,
            pfx: `${_d.i10rc31s}`,
            sch: `${_d.i10rc31s}`,
          }));
          c42v1a.getC40rsAsync({
            c10r_key: global.t?.state.sgcd_cmnStgs.c10r_key,
          })
          .then( _l => {
            _b_1050 = false;
            _l.map( _d => {
              if (_d.c40rc11s == '1050') _b_1050 = true;
            });
            cf.h();
          });
        });
      });



    }
  }, [
    global.t?.state.sgcd_cmnStgs,
  ]);

  const _l_hdrs= (
    ce.c(ce.Box, {
      key: 'hdr',
      d_boxStls: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: ic.s(1.8),
        borderWidth: 0,
        borderBottomWidth: ic.b(0.5),
        borderColor: ic.c('d'),
      },
    }, [ // 
      ce.c(ce.Msg, { // ID
        key: -10,
        pfx: 'ID',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(6),
//          backgroundColor: 'red',
        },
      }),
      ce.c(ce.Msg, { // 利用日
        key: -20,
        pfx: '利用日',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(8),
        },
      }),
      ce.c(ce.Msg, { // 時間帯
        key: -30,
        pfx: '時間帯',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(10),
        },
      }),
      ce.c(ce.Msg, { // 室・設備
        key: -40,
        pfx: '室・設備',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(10),
        },
      }),
      ce.c(ce.Msg, { // 団体
        key: -50,
        pfx: '団体',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(15),
        },
      }),
      ce.c(ce.Msg, { // 利用料
        key: -60,
        pfx: '利用料',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(4),
        },
      }),
      ce.c(ce.Msg, { // 支払状況
        key: -70,
        pfx: '支払状況',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(4),
        },
      }),
      ce.c(ce.Msg, { // 支払方法
        key: -80,
        pfx: '支払方法',
        d_pfxStls: {
          fontSize: ic.s(0.9),
          color: ic.c('d'),
          fontWeight: 'bold',
        },
        d_ctrStls: {
          marginLeft: ic.s(0.5),
          width: ic.s(4),
        },
      }),
    ])
  );

  const _n_lastIdx = ff.myCM_getLen(_sl_i1zrs.crt) - 1;
  const _l_bdys = _sl_i1zrs.crt.map( (_d, _idx) => {
    return (
      ce.c(ce.Box, {
        key: _idx,
        d_boxStls: 
          _idx == _n_lastIdx ?
          {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: ic.s(2.2),
            borderWidth: 0,
            borderBottomWidth: ic.b(0.5),
            borderColor: ic.c('d'),
            marginBottom: ic.s(1),
          }
          :
          {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: ic.s(2.2),
          }
          ,
      }, [ // 
        ce.c(ce.Msg, { // ID
          key: -10,
          pfx: _d.i1zrc11s,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(6),
          },
          o_onPrs: 
            _b_1050 ?
            () => {
              let _d_pageInfs = {
                sgc_pageName: 'i1zv1a',
                sgc_pageRole: global.t?.state.sgc_pageRole,
                sgc_pageMode: 'show',
                sgc_pnlMode: 'dtl',
                sgc_pageFst: _d._fst,
              };
              cf.myRN_move_fwd(_d_pageInfs);
            }
            : null,
        }),
        ce.c(ce.Msg, { // 利用日
          key: -20,
          pfx: _d.i1zri21d,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(8),
          },
        }),
        ce.c(ce.Msg, { // 時間帯
          key: -30,
          pfx: _d.i1zri62s,
          n_lines: 1,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(10),
          },
        }),
        ce.c(ce.Pck, { // 室・設備
          key: -40,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(10),
          },
          ctlVal: _d.i1zrb41f,
          ld_iss: _l_sctI10rs,
        }),
        ce.c(ce.Msg, { // 団体
          key: -50,
          pfx: _d.i1zri61s,
          n_lines: 1,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(15),
          },
        }),
        ce.c(ce.Msg, { // 利用料
          key: -60,
          pfx: _d.i1zri11m,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(4),
          },
        }),
        ce.c(ce.Pck, { // 支払状況
          key: -70,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(4),
          },
          ctlVal: _d.i1z1s11i ?? -1,
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: '未払' },
            { key:  10, pfx: '支払済' },
          ],
        }),
        ce.c(ce.Pck, { // 支払方法
          key: -80,
          d_ctrStls: {
            marginLeft: ic.s(0.5),
            width: ic.s(4),
          },
          ctlVal: _d.i1z1t51i ?? -1,
          ld_iss: [
            { key:  -1, pfx: 'ー' },
            { key:  10, pfx: '窓口' },
            { key:  20, pfx: '事前' },
          ],
        }),
      ])
    );
  });
  return (
    ce.c(ce.RootDtl, {
      key: 'root',
      d_bdys: {
        l_clds: [
          ce.c(ce.Pnl, {
            key: -10,
            mode: 'list',
            d_hdrs: {
              d_ctrs: {
                l_clds: ce.c(_ctrHdr, { key: -10, sl_i1zrs: _sl_i1zrs })
              },
            },
            d_bdys: {
              d_msgBfrs: {
                pfx: 
                  `【支払状況の確認・変更・削除】・・・各予約のIDを押すと詳細画面に移動し、変更、削除もその画面で行えます。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [
                _l_hdrs,
                _l_bdys,
              ],
            },
          })
        ]
      },
    })
  );
};

export default class I1zv8 extends i1zv { // スタッフ用 支払状況確認

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

render() {
  return (
    ce.c(_root, {
      key: 'root',
    })
  );
}

}
